import React from "react";

import { useTranslation } from "react-i18next";
import Skeleton from "@material-ui/lab/Skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@material-ui/core";
import { faPen, faHeadset } from "@fortawesome/pro-solid-svg-icons";

import type { IPartner, IProfile } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";
import { hasUserPermissionAnywhere } from "App/ReactComponents/Shared";

import "./_supporting-partners.scss";

import { SupportingPartnersList } from "./SupportingPartnersList";

type InjectedProps = {
    isLoading: boolean;
    partner: IPartner;
    profile: IProfile;
    isSupportingPartnersDialogOpen: (value: boolean) => void;
};

type SupportingPartnersProps = InjectedProps;

export const SupportingPartners = (props: SupportingPartnersProps) => {
    const { t } = useTranslation();
    const { isLoading, isSupportingPartnersDialogOpen, partner, profile } = props;

    const hasGlobalPermission = hasUserPermissionAnywhere(profile, Permission.GlobalSysAdmin);

    return (
        <div className="card card--alt card--nested card--less-padding">
            {isLoading ? (
                <Skeleton height="4em" />
            ) : (
                <React.Fragment>
                    <div className="partner-details__header-with-edit">
                        <h3 className="title title-h3 supporting-partners__header supporting-partners__header--flex">
                            <FontAwesomeIcon
                                className="supporting-partners__header--icon"
                                icon={faHeadset}
                                fixedWidth
                            />
                            <span className="supporting-partners__header--flex-text">
                                {t("Entities.Partner.SupportingPartners")}
                            </span>
                        </h3>
                        {hasGlobalPermission ? (
                            <IconButton className="icon-button" onClick={() => isSupportingPartnersDialogOpen(true)}>
                                <FontAwesomeIcon className="icon-button__icon" icon={faPen} />
                            </IconButton>
                        ) : null}
                    </div>
                    <SupportingPartnersList partner={partner} />
                </React.Fragment>
            )}
        </div>
    );
};
